'use strict';

/**
* ComboBox custom element.
*/
JQX('jqx-combo-box', function (_JQX$DropDownList) {
    babelHelpers.inherits(ComboBox, _JQX$DropDownList);

    function ComboBox() {
        babelHelpers.classCallCheck(this, ComboBox);
        return babelHelpers.possibleConstructorReturn(this, (ComboBox.__proto__ || Object.getPrototypeOf(ComboBox)).apply(this, arguments));
    }

    babelHelpers.createClass(ComboBox, [{
        key: 'template',


        /**
        * ComboBox's HTML template.
        */
        value: function template() {
            return '<div id="container">\n                    <div id="buttonsContainer" >\n                        <span id="selectionField" class ="jqx-selection-field">\n                            <input id="input" placeholder="[[placeholder]]" />\n                        </span>\n                        <span id="dropDownButton" class ="jqx-drop-down-button jqx-unselectable">&#xe804</span>\n                    </div>\n                    <jqx-list-box id="listBox" class ="jqx-popup jqx-visibility-hidden"\n                            data-source="[[dataSource]]"\n                            disabled="[[disabled]]"\n                            display-loading-indicator="[[displayLoadingIndicator]]"\n                            display-member="[[displayMember]]"\n                            filterable="[[filterable]]"\n                            filter-mode="[[filterMode]]"\n                            filter-input-placeholder="[[filterInputPlaceholder]]"\n                            grouped="[[grouped]]"\n                            group-member="[[groupMember]]"\n                            item-height="[[itemHeight]]"\n                            item-template="[[itemTemplate]]"\n                            incremental-search-delay="[[incrementalSearchDelay]]"\n                            incremental-search-mode="[[incrementalSearchMode]]"\n                            loading-indicator-placeholder="[[loadingIndicatorPlaceholder]]"\n                            loading-indicator-position="[[loadingIndicatorPosition]]"\n                            placeholder="[[dropDownPlaceholder]]"\n                            readonly="[[readonly]]"\n                            selected-indexes="{{selectedIndexes}}"\n                            selection-mode="[[selectionMode]]"\n                            selected-values="{{selectedValues}}"\n                            sorted="[[sorted]]"\n                            value-member="[[valueMember]]"\n                            virtualized="[[virtualized]]">\n                        <content></content>\n                    </jqx-list-box>\n                </div>';
        }

        /**
        * Updates the ComboBox when a property is changed.
        * @param {string} propertyName The name of the property.
        * @param {number/string} oldValue The previously entered value. Max, min and value are of type Number. The rest are of type String.
        * @param {number/string} newValue The new entered value. Max, min and value are of type Number. The rest are of type String.
        */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            var that = this;

            switch (propertyName) {
                case 'dataSource':
                case 'displayMember':
                    //when selectedValues is 0 and displayMember is changed set actionButton text to default.
                    that._clearSelection(true);
                    break;
                case 'disabled':
                    //Needed, because spans are inserted before the input in advanced selectionDisplayMode and atr syncronization doesn't affect the input.
                    that.$.input.disabled = newValue;
                    that.setFocusable(that._focusable === undefined ? true : that._focusable);
                    that.close();
                    break;
                case 'readonly':
                    //Needed, because spans are inserted before the input in advanced selectionDisplayMode and atr syncronization doesn't affect the input.
                    that.$.input.readOnly = newValue;
                    that.close();
                    break;
                case 'selectedValues':
                case 'selectedIndexes':
                    if (newValue.length === 0) {
                        that._clearSelection(true);
                    }

                    break;
                case 'selectionMode':
                case 'selectionDisplayMode':
                    that._applySelectionDisplayMode();
                    if (that.selectionDisplayMode === 'advanced') {
                        that._currentSelection = undefined;
                    }

                    that._applySelection(that.selectionDisplayMode);
                    break;
                default:
                    babelHelpers.get(ComboBox.prototype.__proto__ || Object.getPrototypeOf(ComboBox.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);
                    break;
            }
        }

        /**
        * Removes all items from the ComboBox.
        */

    }, {
        key: 'clearItems',
        value: function clearItems() {
            var that = this;

            that.$.listBox.clearItems();
            that._clearSelection(true);
        }

        /**
        * Unselects all items.
        */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            var that = this;

            that.$.listBox.clearSelection();
            that._clearSelection(arguments[0] ? false : true);
        }

        /**
        * Sets tab index 
        */

    }, {
        key: 'setFocusable',
        value: function setFocusable(focusable) {
            var that = this;

            //Keep track of the focusable state between dropDownOpenMode changes.
            that._focusable = focusable;

            if (!that.disabled && that._focusable) {
                var index = that.tabIndex > 0 ? that.tabIndex : 0;

                that.$.input.tabIndex = index;
                that.dropDownOpenMode === 'dropDownButton' ? that.$.dropDownButton.setAttribute('tabindex', index) : that.$.dropDownButton.removeAttribute('tabindex');
                return;
            }

            that.$.input.tabIndex = -1;
            that.$.dropDownButton.removeAttribute('tabindex');
        }

        /**
        * Fills the selection field with the labels selected items.
        */

    }, {
        key: '_applySelection',
        value: function _applySelection(mode, details) {
            var that = this;

            if (that.selectedIndexes.length === 0) {
                that._clearSelection();
                return;
            }

            if (!that.$.listBox._items || that.$.listBox._items.length === 0) {
                return;
            }

            if (mode === 'default') {
                if (that._currentSelection && that._currentSelection.length > that.selectedIndexes.length) {
                    that._currentSelection = that.selectedIndexes.map(function (i) {
                        return that.$.listBox._items[i].label;
                    });
                    return;
                }

                that._clearSelection();
                that._currentSelection = that.selectedIndexes.map(function (i) {
                    return that.$.listBox._items[i].label;
                });
                that.$.input.value = that._currentSelection.toString();
            } else {
                that.$.input.value = '';
                that.$.input.placeholder = '';

                if (!that._currentSelection || that.selectionMode === 'default') {
                    while (that.$.selectionField.firstElementChild.nodeName === 'SPAN') {
                        that.$.selectionField.removeChild(that.$.selectionField.firstElementChild);
                    }

                    var fragment = document.createDocumentFragment(),
                        element = void 0;

                    that.selectedIndexes.map(function (index) {
                        element = document.createElement('span');
                        element.innerHTML = '<span class=\'jqx-drop-down-list-selection-label\'>' + that.$.listBox._items[index].label + '</span><span class=\'jqx-drop-down-list-unselect-button\'>&#10006</span>';
                        fragment.appendChild(element);
                    });
                    that.$.selectionField.insertBefore(fragment, that.$.input);
                    that._currentSelection = that.selectedIndexes.map(function (i) {
                        return that.$.listBox._items[i].label;
                    });
                    return;
                }

                if (that._currentSelection.length <= that.selectedIndexes.length) {
                    var _element = document.createElement('span');

                    _element.innerHTML = '<span class=\'jqx-drop-down-list-selection-label\'>' + that.$.listBox._items[that.selectedIndexes[that.selectedIndexes.length - 1]].label + '</span><span class=\'jqx-drop-down-list-unselect-button\'>&#10006</span>';
                    that.$.selectionField.insertBefore(_element, that.$.input);
                } else {
                    that.$.selectionField.removeChild(that.$.selectionField.children[that._currentSelection.indexOf(details.label)]);
                }

                that._currentSelection = that.selectedIndexes.map(function (i) {
                    return that.$.listBox._items[i].label;
                });
            }
        }

        /**
        * Sets the selection mode for the ComboBox.
        */

    }, {
        key: '_applySelectionDisplayMode',
        value: function _applySelectionDisplayMode() {
            var that = this;

            if (that.selectionMode !== 'one' && that.selectionMode !== 'none' && that.selectionMode !== 'zeroOrOne') {
                that.selectionDisplayMode = 'advanced';
                that.$.addClass('auto-height');
            } else {
                that.selectionDisplayMode = 'default';
                that.$.removeClass('auto-height');
            }
        }

        /**
        * ComboBox container mouse enter/leave events handler.
        */

    }, {
        key: '_buttonsMouseEventsHandler',
        value: function _buttonsMouseEventsHandler(event) {
            var that = this;

            if (that.disabled || that.readonly) {
                return;
            }

            if (event.type === 'mouseenter') {
                event.target.$.addClass('hovered');

                if (that.dropDownOpenMode === 'auto') {
                    if (event.target === that.$.dropDownButton) {
                        that.open();
                        that.$.input.focus();
                    } else {
                        that.close();
                    }
                }
            } else {
                event.target.$.removeClass('hovered');
            }
        }

        /**
        * Initializes the element.
        */

    }, {
        key: '_createElement',
        value: function _createElement() {
            var that = this;

            if (!JQX.DropDownList) {
                that.error(that.localize('missingReference', { elementType: that.nodeName.toLowerCase(), files: 'jqxdropdownlist.js' }));
            }

            //Set properties.
            babelHelpers.get(ComboBox.prototype.__proto__ || Object.getPrototypeOf(ComboBox.prototype), '_setDropDownSize', this).call(this, 'width', that.dropDownWidth);
            babelHelpers.get(ComboBox.prototype.__proto__ || Object.getPrototypeOf(ComboBox.prototype), '_setDropDownSize', this).call(this, 'height', that.dropDownHeight);
            babelHelpers.get(ComboBox.prototype.__proto__ || Object.getPrototypeOf(ComboBox.prototype), '_setDropDownVerticalPosition', this).call(this, that.dropDownVerticalPosition);
            that._applySelectionDisplayMode();
            that._applySelection(that.selectionDisplayMode);
            that.$.input.disabled = that.disabled;
            that.$.input.readOnly = that.readonly;
            that.setFocusable(true);
        }

        /**
        * Reset the input and clears the selection field.
        */

    }, {
        key: '_clearSelection',
        value: function _clearSelection(resetInput) {
            var that = this;

            if (resetInput) {
                that.$.input.value = '';
            }

            that.$.input.placeholder = that.placeholder;
            that._currentSelection = [];

            while (that.$.selectionField.firstElementChild.nodeName === 'SPAN') {
                that.$.selectionField.removeChild(that.$.selectionField.firstElementChild);
            }
        }

        /**
        * Document Up handler.
        */

    }, {
        key: '_documentUpHandler',
        value: function _documentUpHandler(event) {
            var that = this;
            var target = event.originalEvent.target;

            if (that.disabled || that._isListBoxThumbDragged || that.readonly || target === that.$.input) {
                return;
            }

            if (target === that.$.selectionField) {
                that.$.input.focus();
                return;
            }

            if (target === that.$.dropDownButton && that.dropDownOpenMode !== 'none') {
                that.$listBox.hasClass('jqx-visibility-hidden') ? that.open() : that.close();
                that.$.input.focus();
                return;
            }

            if (target.classList.contains('jqx-drop-down-list-selection-label') && target.parentElement.parentElement === that.$.selectionField && that.dropDownOpenMode !== 'none') {
                that.open();

                var item = that.$.listBox._items.filter(function (item) {
                    return item.label.toString() === target.textContent;
                })[0];

                that.$.listBox.focus();

                //Scroll to that item and focus it.
                that.$.listBox._scrollView.scrollTop = item.offsetTop;
                that._focus(item);
                return;
            }

            if (target.classList.contains('jqx-drop-down-list-unselect-button') && target.parentElement.parentElement === that.$.selectionField) {
                that.unselect(that.$.listBox._items.filter(function (item) {
                    return item.label.toString() === target.previousElementSibling.textContent;
                })[0]);
            }

            while (target) {
                if (target instanceof JQX.ListItem && target.ownerListBox === that.$.listBox) {
                    target = 'item';
                    break;
                } else if (target === that.$.listBox) {
                    target = 'listBox';
                    break;
                }

                target = target.parentElement;
            }

            if (!that.$listBox.hasClass('jqx-visibility-hidden') && target !== 'listBox' && target !== 'item' || target === 'item' && that.selectionDisplayMode !== 'advanced') {
                that.close();
                that.$.input.focus();
                return;
            }
        }

        /**
        * ComboBox input's focus/blur event handler.
        */

    }, {
        key: '_inputFocusHandler',
        value: function _inputFocusHandler(event) {
            var that = this;

            if (that.disabled) {
                return;
            }

            event.type === 'focus' ? that.$.buttonsContainer.setAttribute('focused', '') : that.$.buttonsContainer.removeAttribute('focused');
        }

        /**
        * ComboBox keydown event handler.
        */

    }, {
        key: '_keyDownHandler',
        value: function _keyDownHandler(event) {
            var that = this;

            if (that.disabled || that.readonly || event.target === that.$.listBox.$.filterInput) {
                return;
            }

            that._navigatingThroughItems = false;

            switch (event.key) {
                case 'Enter':
                    if (event.target === that.$.input && that.$.listBox._focusedItem) {
                        if (!that.$.listBox._focusedItem.selected) {
                            that.select(that.$.listBox._focusedItem);
                        }

                        if (!that.$listBox.hasClass('jqx-visibility-hidden')) {
                            that.close();
                            that._unfocus();
                        }
                    } else if (event.target === that.$.dropDownButton) {
                        that.$dropDownButton.addClass('active');
                        that.$listBox.hasClass('jqx-visibility-hidden') && that.dropDownOpenMode !== 'none' ? that.open() : that.close();
                        that._navigatingThroughItems = true;
                        that.$.input.focus();
                    }

                    return;
                case 'Escape':
                    if (!that.$listBox.hasClass('jqx-visibility-hidden')) {
                        that.close();
                        that._unfocus();
                    }

                    break;
                case ' ':
                    if (!that.$listBox.hasClass('jqx-visibility-hidden') && that.selectionDisplayMode === 'advanced') {
                        that.$.listBox._handleKeyStrokes(event.key);
                        event.preventDefault();
                    }

                    that._navigatingThroughItems = true;
                    break;
                case 'End':
                case 'Home':
                case 'PageUp':
                case 'PageDown':
                case 'ArrowUp':
                case 'ArrowDown':
                    that._navigatingThroughItems = true;

                    if (event.altKey) {
                        if (that.$listBox.hasClass('jqx-visibility-hidden') && that.dropDownOpenMode !== 'none') {
                            that.open();
                            if (that.items.length === 0) {
                                return;
                            }

                            if (that.selectedIndexes.length === 0) {
                                that._focus(that.items[0]);
                            } else if (that.selectedIndexes.length > 0 && !that.$.listBox._items[that.selectedIndexes[that.selectedIndexes.length - 1]].hidden) {
                                that._focus(that.items[that.selectedIndexes[that.selectedIndexes.length - 1]]);
                            }
                        } else {
                            that.close();
                        }

                        return;
                    }

                    if (event.target === that.$.input && that.$listBox.hasClass('jqx-visibility-hidden')) {
                        return;
                    }

                    if ((event.key === 'PageUp' || event.key === 'PageDown') && !that.$.listBox._focusedItem || event.target === that.$.listBox.$.filterInput) {
                        return;
                    }

                    event.preventDefault();
                    that.$.listBox._handleKeyStrokes(event.key);
                    break;
                case 'Backspace':
                    if (that.selectionDisplayMode === 'advanced' && that.selectedIndexes.length > 0 && that.$.input.value.length === 0) {
                        that.unselect(that.$.listBox._items[that.selectedIndexes[that.selectedIndexes.length - 1]]);
                    }

                    if (that.selectionDisplayMode === 'default' && that.selectedIndexes.length > 1) {
                        that.clearSelection(true);
                    }

                    break;
                default:
                    if (event.target === that.$.input && that.selectionMode === 'default') {
                        that.$.listBox._keysPressed[event.key] = true;
                    }
            }
        }

        /**
        * ComboBox key up event handler.
        */

    }, {
        key: '_keyUpHandler',
        value: function _keyUpHandler(event) {
            var that = this;

            if (that.disabled || event.key === 'Escape' || event.target === that.$.listBox.$.filterInput) {
                return;
            }

            if (event.target === that.$.input && that.selectionMode === 'default') {
                that.$.listBox._keysPressed[event.key] = false;
            }

            if (event.key === 'Enter') {
                that.$dropDownButton.removeClass('active');
            }

            if (that.selectionDisplayMode === 'default' && that.selectedIndexes.length === 1 && that.$.input.value !== that._currentSelection[0]) {
                that.unselect(that.$.listBox._items[that.selectedIndexes[0]]);
            }

            if (that.$.input.value.length === 0 && !that._navigatingThroughItems) {
                that._unfocus();
                that.close();
                return;
            }

            if (event.target === that.$.input && that.$.input.value.length > 0 && that.$.input.value !== that._currentSelection.toString() && ['Enter', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) < 0) {
                that._unfocus();

                var foundItems = that.$.listBox._queryItems(that.$.input.value, that.incrementalSearchMode);

                for (var i = 0; i < foundItems.length; i++) {
                    if (!foundItems[i].hidden) {
                        that._focus(foundItems[0]);
                        that.$.listBox._scrollView.scrollTop = foundItems[0].offsetTop;
                        if (that.dropDownOpenMode !== 'none') {
                            that.open();
                        }

                        break;
                    }
                }
            }
        }

        /**
        * Mouse wheel event handler.
        */

    }, {
        key: '_mouseWheelHandler',
        value: function _mouseWheelHandler(event) {
            var that = this;

            if (that.disabled || that.readonly || that.items.length === 0) {
                return;
            }

            if (!that.$listBox.hasClass('jqx-visibility-hidden')) {
                return;
            }

            that.$.listBox._handleKeyStrokes(event.deltaY > 0 ? 'ArrowDown' : 'ArrowUp');
        }

        /**
        * Document select start event handler.
        */

    }, {
        key: '_selectStartHandler',
        value: function _selectStartHandler(event) {
            if (this.$.input === document.activeElement) {
                return;
            }

            event.preventDefault();
        }

        /**
        * Unfocuses the focused list item from the ComboBox.
        */

    }, {
        key: '_unfocus',
        value: function _unfocus() {
            var that = this;

            if (!that.$.listBox._focusedItem) {
                return;
            }

            that.$.listBox._focusedItem.focused = false;
            that.$.listBox._focusedItem = undefined;
        }
    }], [{
        key: 'listeners',


        /**
        * ComboBox's event listeners.
        */
        get: function get() {
            return {
                'input.mouseenter': '_buttonsMouseEventsHandler',
                'input.mouseleave': '_buttonsMouseEventsHandler',
                'input.focus': '_inputFocusHandler',
                'input.blur': '_inputFocusHandler',
                'document.down': '_documentDownHandler',
                'document.up': '_documentUpHandler',
                'document.selectstart': '_selectStartHandler',
                'dropDownButton.down': '_buttonsDownHandler',
                'dropDownButton.mouseenter': '_buttonsMouseEventsHandler',
                'dropDownButton.mouseleave': '_buttonsMouseEventsHandler',
                'keydown': '_keyDownHandler',
                'keyup': '_keyUpHandler',
                'listBox.change': '_listBoxChangeHandler',
                'listBox.keydown': '_listBoxKeyDownHandler',
                'wheel': '_mouseWheelHandler'
            };
        }
    }]);
    return ComboBox;
}(JQX.DropDownList));